module.exports = __webpack_public_path__ + "static/media/galerija_2017 (21).eb4d578e.jpg";